<form
  class="user--trade-url flex gap-8 items-center w-full"
  [formGroup]="tradeURLForm"
  (ngSubmit)="tradeURLSubmit()"
  #tradeURLFormRef="ngForm"
>
  <div class="form-field form-field--input-icon w-full">
    <label
      >Steam Trade URL (<a
        target="_blank"
        href="https://steamcommunity.com/profiles/{{
          sessionService.profile()?.steamid
        }}/tradeoffers/privacy#trade_offer_access_url"
        class="highlight"
        >Click to get</a
      >)
      <span
        [class.error]="
          !tradeURLForm.get('tradeURL')?.valid && tradeURLFormRef['submitted']
        "
      >
        @if (tradeURLForm.get('tradeURL')?.hasError('required') ) { Field is
        required }
        <!--  -->
        @if (tradeURLForm.get('tradeURL')?.hasError('pattern') ) { Invalid Trade
        URL format }
      </span>
    </label>
    <div
      class="input-container w-full flex items-center"
      [class.focus]="
        onMountFocusTradeURL() &&
        !tradeURLFormRef.dirty && !tradeURLFormRef['submitted']
      "
    >
      <svg-icon class="rounded-full s-16" [src]="'assets/icons/ui/steam.svg'" />
      <input
        #tradeURLInput
        formControlName="tradeURL"
        placeholder="Paste your Trade URL link here"
        [value]="sessionService.stats().trade_url"
        type="text"
      />
    </div>
  </div>
  <button
    type="submit"
    class="button button--style-yellow h-36 padding-x-12"
    [disabled]="tradeURLForm.invalid"
  >
    Save
  </button>
</form>
